import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  batchSearchProgressModalSetProgressStatusReducerType,
  batchSearchProgressModalSetQueryRunningReducerType,
  batchSearchProgressModalSetQueriesTotalReducerType,
  batchSearchProgressModalSetStatusReducerType,
  batchSearchProgressModalSetProgressPercentageReducerType,
  BATCH_SEARCH_PROGRESS_MODAL_STATUS,
} from './BatchSearchProgressModalConstants';

export const initialState = Map({
  singleDatabase: false,
  progressStatus: null,
  queryRunning: 1,
  queriesTotal: 1,
  status: BATCH_SEARCH_PROGRESS_MODAL_STATUS.RUNNING,
  progressPercentage: 0,
});

const spec = {
  [batchSearchProgressModalSetProgressStatusReducerType]: (state, action) => {
    const { progressStatus } = action.payload;
    return state.set('progressStatus', progressStatus);
  },
  [batchSearchProgressModalSetQueryRunningReducerType]: (state, action) => {
    const { queryRunning } = action.payload;
    return state.set('queryRunning', queryRunning);
  },
  [batchSearchProgressModalSetQueriesTotalReducerType]: (state, action) => {
    const { queriesTotal } = action.payload;
    return state.set('queriesTotal', queriesTotal);
  },
  [batchSearchProgressModalSetStatusReducerType]: (state, action) => {
    const { status } = action.payload;
    return state.set('status', status);
  },
  [batchSearchProgressModalSetProgressPercentageReducerType]: (state, action) => {
    const { progressPercentage } = action.payload;
    return state.set('progressPercentage', progressPercentage);
  },
};

export default createReducerBySpec(spec, initialState);
